import React from 'react'
import { render, screen } from '@testing-library/react'
import ImageCard from '../ImageCard'
import { ImageCardProps } from '../types.d'

const baseProps: ImageCardProps = {
  ctaLabel: 'Link Label',
  ctaLink: '#testLink',
  image: [
    {
      extension: 'png',
      url: 'https://d2w1ef2ao9g8r9.cloudfront.net/images/demo@2x.png',
      title: 'demo',
      optimizedImages: {
        srcAvif:
          'https://d2w1ef2ao9g8r9.cloudfront.net/images/_1600x1575_crop_center-center_82_line/demo@2x.png.webp'
      }
    }
  ],
  linkIcons: 'arrow',
  padding: '24',
  sectionHeading: 'Heading',
  sectionDescription:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pulvinar ante. Etiam vel lacus ut mauris sodales pharetra.',
  textAlignment: 'center'
}

describe('Image Card Tests', () => {
  it('Should Render ImageCard with White BG, Light Border, and Raised Elevation', () => {
    render(
      <ImageCard
        {...baseProps}
        bgColor='bg-white'
        cardBorderColor='light'
        elevation='raised'
      />
    )

    // Get ImageCard container element by id
    const imagecard = screen.getByTestId('ImageCard-1')
    expect(imagecard).toBeTruthy()
    expect(imagecard).toHaveClass(
      'bg-white',
      'border-card-light',
      'shadow-raised'
    )

    // Get H4 element
    const heading = screen.getByRole('heading', { level: 4 })
    expect(heading).toBeTruthy()
    expect(heading.classList.contains('text-default')).toBe(true)
    expect(heading.textContent).toBe('Heading')

    // Get Paragraph element by text
    const description = screen.getByText(
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pulvinar ante. Etiam vel lacus ut mauris sodales pharetra.'
    )
    expect(description).toBeTruthy()
    expect(description.classList.contains('text-gray-100')).toBe(true)

    // Get Link element By Role Link & check icon
    const cta = screen.getByRole('link')
    expect(cta).toBeTruthy()
    expect(screen.getByTestId('TextLinkIcons-arrow')).toBeTruthy()
  })

  it('Should Render ImageCard with Gray BG, No Border, and Flat Elevation', () => {
    render(<ImageCard {...baseProps} bgColor='bg-gray-0' elevation='flat' />)

    // Get ImageCard container element by id
    const imagecard = screen.getByTestId('ImageCard-1')
    expect(imagecard).toBeTruthy()
    expect(imagecard).toHaveClass('bg-gray-0')

    // Get H4 element
    const heading = screen.getByRole('heading', { level: 4 })
    expect(heading).toBeTruthy()
    expect(heading.classList.contains('text-default')).toBe(true)
    expect(heading.textContent).toBe('Heading')

    // Get Paragraph element by text
    const description = screen.getByText(
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pulvinar ante. Etiam vel lacus ut mauris sodales pharetra.'
    )
    expect(description).toBeTruthy()
    expect(description.classList.contains('text-gray-100')).toBe(true)

    // Get Link element By Role Link & check icon
    const cta = screen.getByRole('link')
    expect(cta).toBeTruthy()
    expect(screen.getByTestId('TextLinkIcons-arrow')).toBeTruthy()
  })

  it('Should Render ImageCard with Mp4 File', () => {
    const props = Object.assign(baseProps, {
      image: [
        {
          extension: 'mp4',
          url: 'https://d2w1ef2ao9g8r9.cloudfront.net/images/opt-animation.mp4',
          filename: 'opt-animation.mp4'
        }
      ]
    })

    render(<ImageCard {...props} bgColor='bg-gray-0' elevation='flat' />)
    // Get ImageCard container element by id
    expect(screen.getByTestId('video-animation')).toBeTruthy()
  })

  it('Should Render ImageCard with Lottie File', () => {
    const props = Object.assign(baseProps, {
      image: [
        {
          extension: 'json',
          url: 'https://assets3.lottiefiles.com/packages/lf20_UJNc2t.json',
          title: 'lottieFile'
        }
      ]
    })

    render(<ImageCard {...props} bgColor='bg-gray-0' elevation='flat' />)
    // Get ImageCard container element by id
    expect(screen.getByTestId('lottie-player')).toBeTruthy()
  })
})
